var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFC866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0322 15.0331C13.0322 15.0331 13.0322 7.55228 13.0322 7C13.0322 6.44772 12.5845 6 12.0322 6C11.4799 6 11.0322 6.44772 11.0322 7C11.0322 7.55228 11.0322 15.0331 12.0322 15.0331ZM11.9648 18C12.5171 18 12.9648 17.5523 12.9648 17C12.9648 16.4477 12.5171 16 11.9648 16C11.4126 16 10.9648 16.4477 10.9648 17C10.9648 17.5523 11.4126 18 11.9648 18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "react/media/status.ee383a63cd856a8a7a8ab43b1c0f9aa2.svg";
export { ForwardRef as ReactComponent };